module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAXCAYAAADpwXTaAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD2SURBVHgBzZTBDYIwFEDb0gTCiRFwAljBDXAEDyRwqxvgBPbIDdzADVyBERyBG5zA/xM0RgXaYgwvKU366YO2/5eQtULTNI26risopZ7C+/s8z8vXgTiOQ8bYte/7I4fHSVH0wUOE86EFHMb8IbaBr94MRZVt2wdGDPgi2kopa23ZmAhjWrIpkZZsToTwpSIhhNc0TQHx86xs7o/atg1hPIIUC9kS0TvsVyJkdJmWZQnolEWTMiCDmq1c1y1VRJOyobQk0cConP4iey4T8iRIksQnmsC+4qnj/JrjaWHCQX8hBqAIQQ9ejjto0vSCHKgcx8nIarkDnFF/NXpbbzcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/createBankAccount/edit.png
// module id = qn31
// module chunks = 0